import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from '@app/services/http.service';
import { environment } from '@env/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RouteDataService {

  private routeData: BehaviorSubject<{[k: string]: any}> = new BehaviorSubject<{[k: string]: any}>({}); // persistent cache data
  public routeData$: Observable<{[k: string]: any}> = this.routeData.asObservable();
  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();

  constructor(
    private httpService: HttpService
  ) { 
    // setup all persistent data
  }

  setPreviousUrl( previousUrl: string ): void {
    this.previousUrl.next( previousUrl );
  }

  clearRouteData(): void {
    this.routeData.next({
      'codes': [],
      'hospitals': [],
      'statuses': [],
      'physicians': []
    });
  }

  setRouteData( data: any, key: string ): void {
    let currentValue = this.routeData.getValue();
    // console.log( 'RouteDataService.setRouteData(): ', currentValue );
    currentValue[key] = data;
    this.routeData.next(currentValue);
  }

  loadAndCache<T>(
    key: string,
    path: string[],
    queryParams: any = {}
  ): Observable<T[]> {
    const url = this.httpService.createUrl(
      path, 
      { queryParams }, 
      { host: environment.host_api_default }
    );

    return this.httpService.get<T[]>(url).pipe(
      tap(result => this.setRouteData(result, key))
    );
  }

}
